import { GET_LANDING_PAGE_INFO, LANDING_PAGE_INFO_ERROR } from "../types";

const initialState = {
  landingPageInfo: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LANDING_PAGE_INFO:
      return {
        ...state,
        landingPageInfo: action.payload,
        loading: false,
      };
    case LANDING_PAGE_INFO_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
